import { Head } from '@/components/Head';
import { PublicLayout, Logout as LogoutComponent } from '@/components/Layout';

export const Logout = () => {
  return (
    <PublicLayout className="flex">
      <Head />
      <LogoutComponent />
    </PublicLayout>
  );
};
